<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert, useTrack } from 'dashboard/composables';
import { CAMPAIGN_TYPES } from 'shared/constants/campaign.js';
import { CAMPAIGNS_EVENTS } from 'dashboard/helper/AnalyticsHelper/events.js';

import EmailCampaignForm from 'dashboard/components-next/Campaigns/Pages/CampaignPage/EmailCampaign/EmailCampaignForm.vue';

const emit = defineEmits(['close']);

const store = useStore();
const { t } = useI18n();

const addCampaign = async campaignDetails => {
  try {
    await store.dispatch('campaigns/create', campaignDetails);

    useTrack(CAMPAIGNS_EVENTS.CREATE_CAMPAIGN, {
      type: CAMPAIGN_TYPES.ONE_OFF,
    });

    useAlert(t('CAMPAIGN.EMAIL.CREATE.FORM.API.SUCCESS_MESSAGE'));
    emit('close');
  } catch (error) {
    const errorMessage =
      error?.response?.message ||
      t('CAMPAIGN.EMAIL.CREATE.FORM.API.ERROR_MESSAGE');
    useAlert(errorMessage);
  }
};

const handleSubmit = campaignDetails => {
  addCampaign(campaignDetails);
};

const handleClose = () => emit('close');
</script>

<template>
  <!-- Modal Overlay -->
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
    @click.self="handleClose"
  >
    <!-- Modal Content - 60% width -->
    <div
      class="w-[60%] max-w-5xl bg-n-alpha-3 backdrop-blur-[100px] rounded-xl border border-n-weak shadow-2xl max-h-[90vh] overflow-hidden flex flex-col"
    >
      <!-- Header -->
      <div
        class="px-6 py-4 border-b border-n-weak flex items-center justify-between flex-shrink-0"
      >
        <h3 class="text-lg font-semibold text-n-slate-12">
          {{ t(`CAMPAIGN.EMAIL.CREATE.TITLE`) }}
        </h3>
        <button
          type="button"
          class="p-1.5 rounded-lg hover:bg-n-alpha-2 transition-colors"
          @click="handleClose"
        >
          <svg
            class="w-5 h-5 text-n-slate-11"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <!-- Form Content - Scrollable -->
      <div class="px-6 py-6 overflow-y-auto flex-1">
        <EmailCampaignForm @submit="handleSubmit" @cancel="handleClose" />
      </div>
    </div>
  </div>
</template>
